import codeMessage from "./codeMessage";
import { toast } from "react-toastify";
const successHandler = (
  response,
  options = { notifyOnSuccess: false, notifyOnFailed: true }
) => {
  const { data } = response;
  if (response && response.status === 200) {
    const message = response.data && data.message;
    const successText = message || codeMessage[response.status];
    const { status } = response;
    if (options.notifyOnSuccess) {
      return toast.success(successText);
      // return toast()
      //   .success(status, successText)
      //   .with({
      //     shape: "pill",
      //     duration: 1000,
      //     speed: 1000,
      //     positionX: "end",
      //     icon: "fa fa-check-circle",
      //     positionY: "top",
      //     color: "bg-white",
      //     fontColor: "white",
      //     fontTone: "bg-lightBlue-900",
      //   })
      //   .show();

      // Notification	.config({
      // 	duration: 5,
      // });
      // Notification.success({
      // 	message: `Request success`,
      // 	description: successText,
      // });
    }
  } else {
    //const message = response.data && data.message;
    const errorText = codeMessage[response.status];
    const { status } = response;
    if (options.notifyOnFailed) {
      return toast.error(errorText);

      // notification.config({
      // 	duration: 5,
      // });
      // notification.error({
      // 	message: `Request error ${status}`,
      // 	description: errorText,
      // });
    }
  }
};

export default successHandler;
